// extracted by mini-css-extract-plugin
export default {"press__container":"PressCard_press__container__iWwRi","text__button__container":"PressCard_text__button__container__339Td","press__button":"PressCard_press__button__SZe88"};